import styles from './style.module.css';

const ContentBlock = ({
  heading,
  content,
  headingColor,
  textColor,
}: {
  heading: string;
  content: string;
  headingColor?: string;
  textColor?: string;
}) => {
  return (
    <div className={styles.container}>
      <p style={{ color: headingColor || 'inherit' }} className={styles.heading}>
        {heading}
      </p>
      <p style={{ color: textColor || 'inherit' }} className={styles.content}>
        <span className={styles.contentOne}>{content}</span>
      </p>
    </div>
  );
};

export default ContentBlock;
